import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "component-dns-records component-txt-records" }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = {
  key: 0,
  class: "mt-3 mb-2 font-medium text-lg"
}
const _hoisted_4 = {
  key: 1,
  class: "grid grid-cols-1 gap-3 items-stretch sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5"
}
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = { class: "grow flex flex-col p-5 bg-white" }
const _hoisted_7 = { class: "inline-block pb-3 text-lg font-medium" }
const _hoisted_8 = {
  key: 0,
  class: "card-text verification-code mb-2"
}
const _hoisted_9 = { class: "card-text verification-code" }
const _hoisted_10 = { class: "grow mt-2 flex flex-col justify-end" }
const _hoisted_11 = { class: "text-sm text-gray-500" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("h3", { class: "mt-5 mb-2 font-medium text-lg" }, "SPF record", -1)
const _hoisted_13 = {
  key: 3,
  class: "mt-3 mb-2 font-medium text-lg"
}
const _hoisted_14 = {
  key: 4,
  class: "w-full"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("colgroup", null, [
  /*#__PURE__*/_createElementVNode("col", { class: "w-2/3" }),
  /*#__PURE__*/_createElementVNode("col", { class: "w-1/3" })
], -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "border-b-2 border-gray-200 text-left" }, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "py-1.5 font-medium"
    }, "TXT data"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "py-1.5 font-medium"
    }, "Revalidate in")
  ])
], -1)
const _hoisted_17 = { class: "py-1 break-all" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400" }, "\"", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400" }, "\" ", -1)
const _hoisted_20 = { key: 2 }

import { computed, PropType } from 'vue';
import { useStore } from 'vuex';
import Duration from '@/components/micro/DurationComponent.vue';
import RawRecords from '@/components/micro/RawRecords.vue';
import Copy from '@/components/micro/CopyComponent.vue';
import CnameChainBadge from '@/components/micro/CnameChainBadge.vue';
import SpfRecords from '@/components/records/SpfRecords.vue';
import { Term } from '@/model/Spf';
import { QueryResult, RecordInfo, TXT } from '@/model/Api';

type TxtRecordWithInfo = {
  record: TXT;
} & RecordInfo

type VerificationRecord = {
  type: 'verification';
  org: string;
  verificationIdentifier: string;
  verificationCode: string;
}

type SpfRecord = {
  terms: Array<Term>;
}

type OtherRecord = {
  type: 'other';
  strings: string[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TxtRecords',
  props: {
  records: {
    type: Object as PropType<QueryResult>,
    required: true,
  },
  domain: {
    type: String,
    required: true,
  },
},
  setup(__props) {

const props = __props;

const verificationConfig = [
  { org: 'Google', prefix: 'google-site-verification', separator: '=' },
  { org: 'Microsoft', prefix: 'MS', separator: '=' },
  { org: 'Facebook', prefix: 'facebook-domain-verification', separator: '=' },
  { org: 'GlobalSign', prefix: '_globalsign-domain-verification', separator: '=' },
  { org: 'Adobe identity provider', prefix: 'adobe-idp-site-verification', separator: '=' },
  { org: 'Atlassian', prefix: 'atlassian-domain-verification', separator: '=' },
  { org: 'Amazon SES', prefix: 'amazonses', separator: ':' },
  { org: 'DocuSign', prefix: 'docusign', separator: '=' },
  { org: 'Yandex', prefix: 'yandex-verification', separator: ':' },
  { org: 'GlobalSign', prefix: 'globalsign-domain-verification', separator: '=' },
  { org: 'Zoom', prefix: 'ZOOM_verify', separator: '_' },
  { org: 'Pardot', prefix: 'pardot', separator: '=' },
  { org: 'Apple', prefix: 'apple-domain-verification', separator: '=' },
  { org: 'Apple', prefix: 'apple-domain', separator: '=' },
  // TODO
  // eslint-disable-next-line no-tabs
  // spf2.0	amazon.com.	spf2.0/pra include:spf1.amazon.com include:spf2.amazon.com include:amazonses.com -all
  { org: 'Ahrefs', prefix: 'ahrefs-site-verification', separator: '_' },
  { org: 'Cisco CI', prefix: 'cisco-ci-domain-verification', separator: '=' },
  { org: 'Sendinblue', prefix: 'Sendinblue-code', separator: ':' },
  { org: 'Zoho', prefix: 'zoho-verification', separator: '=' },
  // TODO
  // eslint-disable-next-line no-tabs
  // v=DMARC1;	springer.com.	v=DMARC1; p=none; pct=100; rua=mailto:re+undujzcqrz6@dmarc.postmarkapp.com; sp=none; aspf=r;
  { org: 'Mail.ru', prefix: 'mailru-verification', separator: ': ' },
  // TODO
  // eslint-disable-next-line no-tabs
  // v=DKIM1;	webmd.com.	v=DKIM1; k=rsa; p=MIIBIjANB\" \"gkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAglkiu3gC0LOVJ8uWLfw8Ykk9tEFFL/EdXmMFBDUZSHMtPKRG0LBUBsmV/piNw1xsjg+nR3zpqqu68DeV/2GnFTvcKu02YJS7B6T7ibL/One14BoZW5Hpdp2LEnQxmrMxGjlzZHvwI9+3w9qgpo1jCe34jKW2pr6ext5cX7SxyNO41c5l4QgI4oJu3GGq2l" "6CMN+OJAc54GU4ofetwS+L8gcWK86\" \"+ebMilGq3OgpowJZATl27ii7KiIHxZXixNLB5nDVPKrmuN4jcYEYGPEVELK4X/NxZWGTiZoFRXxwTDZYaBrDyxvOoFbQqwwOHfrMHHwTSTSRH5eLp2CGmMQtutwIDAQAB
  { org: 'Statuspage', prefix: 'status-page-domain-verification', separator: '=' },
  { org: 'Webex', prefix: 'webexdomainverification.', separator: '=' },
  { org: 'Microsoft', prefix: 'ms', separator: '=' },
  { org: 'KnownBe4', prefix: 'knowbe4-site-verification', separator: '=' },
  { org: 'Stripe', prefix: 'stripe-verification', separator: '=' },
  { org: 'Cisco CI', prefix: 'ciscocidomainverification', separator: '=' },
  { org: 'Have I been pwned', prefix: 'have-i-been-pwned-verification', separator: '=' },
  { org: 'QuoVadis', prefix: 'QuoVadis', separator: '=' },
  { org: 'Dropbox', prefix: 'dropbox-domain-verification', separator: '=' },
  { org: 'Brave ledger', prefix: 'brave-ledger-verification', separator: '=' },
  { org: 'LogMeIn', prefix: 'logmein-verification-code', separator: '=' },
  { org: 'Workplace', prefix: 'workplace-domain-verification', separator: '=' },
  { org: 'OneTrust', prefix: 'onetrust-domain-verification', separator: '=' },
  { org: 'Adobe Sign', prefix: 'adobe-sign-verification', separator: '=' },
  // TODO
  // eslint-disable-next-line no-tabs
  // k=rsa;	nypost.com.	k=rsa; p=MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDiTxvTgpRaUPa3Zsawin7pRP+CPIij6s1io0EsxRAfrCox6uw/QdKyEiozMHKz14AWPx6gLqb09Om7xmN9Snb5tcnWQdD46XFld1rm+DVwP1UezK/VagJDp6aMhabY1T1hBpK4R/YBnQ70R1AivL6Km7TfNgRU6UMSx2TtQnkFawIDAQAB
  { org: 'Firebase', prefix: 'firebase', separator: '=' },
  { org: 'Klaviyo', prefix: 'klaviyo-site-verification', separator: '=' },
  { org: 'Loader.io', prefix: 'loaderio', separator: '=' },
  { org: 'Salesforce Marketing Cloud', prefix: 'SFMC', separator: '-' }, // Not sure if this is correct..
  { org: 'Citrix', prefix: 'citrix-verification-code', separator: '=' },
  { org: 'Emma', prefix: 'e2ma-verification', separator: '=' },
  { org: 'Sophos', prefix: 'sophos-domain-verification', separator: '=' },
  { org: 'Detectify', prefix: 'detectify-verification', separator: '=' },
  { org: 'Dynamics 365 marketing', prefix: 'd365mktkey', separator: '=' },
  { org: 'Mail.ru', prefix: 'mailru-domain', separator: ': ' },
  { org: 'Keybase', prefix: 'keybase-site-verification', separator: '=' },
  { org: 'Postman', prefix: 'postman-domain-verification', separator: '=' },
  { org: 'SwissSign', prefix: 'swisssign-check', separator: '=' },
  { org: 'ProtonMail', prefix: 'protonmail-verification', separator: '=' },
  { org: 'Dynatrace', prefix: 'Dynatrace-site-verification', separator: '=' },
  { org: 'Smartsheet', prefix: 'smartsheet-site-validation', separator: '=' },
  { org: 'TeamViewer', prefix: 'teamviewer-sso-verification', separator: '=' },
  { org: 'Wrike', prefix: 'wrike-verification', separator: '=' },
  { org: 'Miro', prefix: 'miro-verification', separator: '=' },
  { org: 'Dailymotion', prefix: 'dailymotion-domain-verification', separator: '=' },
  { org: 'MongoDB', prefix: 'mongodb-site-verification', separator: '=' },
  { org: 'Segment', prefix: 'segment-site-verification', separator: '=' },
  { org: 'Fastly', prefix: 'fastly-domain-delegation', separator: '-' },
  { org: 'Pax8', prefix: 'pax8validat', separator: 'e' }, // Doesn't use a verification code
  { org: 'eSputnik', prefix: 'esputnik-verification', separator: '=' },
  { org: 'CloudHealth', prefix: 'cloudhealth', separator: '=' },
  // TODO
  // eslint-disable-next-line no-tabs
  // _acme-challenge	chosun.com.	_acme-challenge.sandbox.chosun.com.=WQZ-txQ8JpD8amqBbabzVkHdqj_f9xJ57ixWAjMOiOw
  { org: 'GoDaddy', prefix: 'godaddyverification', separator: '=' },
  { org: 'SpyCloud', prefix: 'spycloud-domain-verification', separator: '=' },
  // TODO: Unknown verification record
  // eslint-disable-next-line no-tabs
  // hj-ownership	homedepot.com.	hj-ownership=0ZCtxdHCuFnR
  { org: 'Bugcrowd', prefix: 'bugcrowd-verification', separator: '=' },
  { org: 'Botify', prefix: 'botify-site-verification', separator: '=' },
  { org: 'Heroku', prefix: 'heroku-domain-verification', separator: '=' },
  { org: 'Drift', prefix: 'drift-domain-verification', separator: '=' },
  { org: 'Mixpanel', prefix: 'mixpanel-domain-verify', separator: '=' },
  { org: 'Intacct ESK', prefix: 'intacct-esk', separator: '=' },
  { org: 'Traction Guest', prefix: 'traction-guest', separator: '=' },
  { org: 'AbuseIPDB', prefix: 'abuseipdb-verification', separator: '=' },
  { org: 'Aliyun', prefix: 'aliyun-site-verification', separator: '=' },
  { org: 'Zapier', prefix: 'zapier-domain-verification-challenge', separator: '=' },
  { org: 'HackerOne', prefix: 'h1-domain-verification', separator: '=' },
  { org: 'GitHub', prefix: '_github-challenge-', separator: '=' },
  { org: 'Virtru', prefix: 'virtru-site-verify', separator: '=' },
  { org: 'Nintex', prefix: 'nintex', separator: '.' },
  { org: 'Mail QQ', prefix: 'qqmail-site-verification', separator: '=' },
  { org: 'Beam', prefix: 'beam-verification', separator: '=' },
  { org: 'Trustpilot', prefix: 'Trustpilot-Verification', separator: '-' },
  { org: 'Canva', prefix: 'canva-site-verification', separator: '=' },
  { org: 'FortiFi', prefix: 'fortifi-domain-verification', separator: '=' },
  { org: 'Loom', prefix: 'loom-site-verification', separator: '=' },
  { org: 'Loom', prefix: 'loom-verification', separator: '=' },
  { org: 'Meltwater', prefix: 'meltwater', separator: '_' },
  { org: 'Mandrill', prefix: 'mandrill_verify', separator: '.' },
  { org: 'Cloudflare', prefix: 'cloudflare-verify', separator: '.' },
  { org: 'Docker', prefix: 'docker-verification', separator: '=' },
  { org: 'Fastly', prefix: 'Fastly-Domain-Verify', separator: '-' },
  { org: 'Pendo', prefix: 'pendo-domain-verification', separator: '=' },
  { org: 'Notion', prefix: 'notion-domain-verification', separator: '=' },
  { org: 'Notion', prefix: 'notion_verify', separator: '_' },
  { org: 'Nulab', prefix: 'nulab-verification-code', separator: '=' },
  { org: 'HEY', prefix: 'hey-verification', separator: ':' },
  { org: 'HubSpot', prefix: 'hubspot-domain-verification', separator: '=' },
  { org: 'Slack', prefix: 'slack-domain-verification', separator: '=' },
  { org: 'Webflow', prefix: 'proxy-ssl.webflow.com', separator: '' },
  { org: 'Shopify', prefix: 'shopify-verification-code', separator: '=' },
  { org: 'IdenTrust', prefix: 'identrust_validate', separator: '=' },
  { org: 'Duo', prefix: 'duo_sso_verification', separator: '=' },
  { org: '1Password', prefix: '1password-site-verification', separator: '=' },
  { org: 'Flexera', prefix: 'flexera-domain-verification', separator: '-' },
  { org: 'Appspace', prefix: 'appspace-domain-verification', separator: '=' },
  { org: 'Atlassian', prefix: 'atlassian-sending-domain-verification', separator: '=' },
  { org: 'Actalis', prefix: 'actalis-dcv', separator: '=' },
  { org: 'Intersight', prefix: 'intersight', separator: '=' },
  { org: 'Twilio', prefix: 'twilio-domain-verification', separator: '=' },
  { org: 'Wiz', prefix: 'wiz-domain-verification', separator: '=' },
  { org: 'Vmware Cloud', prefix: 'vmware-cloud-verification', separator: '-' },
  { org: 'Pinterest', prefix: 'pinterest-site-verification', separator: '=' },
  { org: 'GitHub', prefix: 'github-verification', separator: '=' },
  { org: 'Proofpoint', prefix: 'ppe', separator: '-' },
  { org: 'SimpleLogin', prefix: 'sl-verification', separator: '=' },
  { org: 'Dan', prefix: 'dan-ownership-verification', separator: '=' },
  { org: 'Paloalto networks', prefix: 'paloaltonetworks-site-verification', separator: '=' },
  { org: 'Afternic', prefix: 'afternic-verification', separator: '-' },
  { org: 'Validity', prefix: 'Validity-Domain-Verification', separator: '=' },
  { org: 'Autodesk', prefix: 'autodesk-domain-verification', separator: '=' },
  { org: 'Jamf', prefix: 'jamf-site-verification', separator: '=' },
  { org: 'Apple', prefix: 'apple-domain', separator: '=' },
  { org: 'OpenAI', prefix: 'openai-domain-verification', separator: '=' },
  { org: 'Forward Email (paid)', prefix: 'forward-email-site-verification', separator: '=' },
  { org: 'Forward Email (free)', prefix: 'forward-email', separator: '=' },
  { org: 'Yahoo', prefix: 'yahoo-verification-key', separator: '=' },
  { org: 'Lucid', prefix: 'lucid-verification', separator: '=' },
  { org: 'Dell', prefix: 'dell-technologies-domain-verification=', separator: '_' },
];



const store = useStore();
const showRawOutput = computed(() => store.state.showRawOutput);

function parse(strings: string[]): VerificationRecord | OtherRecord {
  if (strings.length === 1) {
    const config = verificationConfig.find((c) => strings[0].startsWith(c.prefix));
    if (config) {
      const recordWithoutPrefix = strings[0].substring(config.prefix.length);
      if (recordWithoutPrefix.startsWith(config.separator)) {
        return {
          type: 'verification',
          org: config.org,
          verificationIdentifier: '',
          verificationCode: recordWithoutPrefix.substring(config.separator.length),
        } as VerificationRecord;
      }
      const separatorIndex = recordWithoutPrefix.indexOf(config.separator);
      return {
        type: 'verification',
        org: config.org,
        verificationIdentifier: recordWithoutPrefix.substring(0, separatorIndex),
        verificationCode: recordWithoutPrefix.substring(separatorIndex + 1),
      };
    }
  }

  return {
    type: 'other',
    strings,
  };
}

const processedRecords = computed(() => {
  const processed = {
    verification: Array<VerificationRecord & {ttl: number}>(),
    spf: Array<SpfRecord & {ttl: number}>(),
    other: Array<OtherRecord & {raw: string; ttl: number; cnameChain: Array<string>}>(),
  };
  props.records.response.answer
    .filter((item): item is TxtRecordWithInfo => item.record.recordType === 'TXT')
    .forEach((r) => {
      if (r.parsedSpf) {
        processed.spf.push({ terms: r.parsedSpf, ttl: r.record.ttl });
      } else if (r.record.raw) {
        const parsed = parse(r.record.strings);
        if (parsed.type === 'verification') {
          processed.verification.push({ ttl: r.record.ttl, ...parsed });
        } else {
          processed.other.push({
            raw: r.record.raw, ttl: r.record.ttl, cnameChain: r.cnameChain, ...parsed,
          });
        }
      }
    });

  processed.verification.sort((a, b) => a.org.localeCompare(b.org));
  return processed;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(showRawOutput))
      ? (_openBlock(), _createBlock(RawRecords, {
          key: 0,
          records: __props.records
        }, null, 8, ["records"]))
      : (_unref(processedRecords).verification.length + _unref(processedRecords).other.length + _unref(processedRecords).spf.length !== 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (_unref(processedRecords).verification.length !== 0)
              ? (_openBlock(), _createElementBlock("h3", _hoisted_3, "Site ownership verification"))
              : _createCommentVNode("", true),
            (_unref(processedRecords).verification.length !== 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(processedRecords).verification, (record, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: "flex flex-col w-full break-words rounded overflow-hidden shadow-sm bg-gray-100 border border-gray-300"
                    }, [
                      _createElementVNode("img", {
                        src: 'img/components/txt-records/' + record.org + '.png',
                        alt: `${record.org} logo`,
                        width: "128",
                        height: "104",
                        class: "mx-auto py-8"
                      }, null, 8, _hoisted_5),
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("span", _hoisted_7, _toDisplayString(record.org), 1),
                        (record.verificationIdentifier !== '')
                          ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(record.verificationIdentifier), 1))
                          : _createCommentVNode("", true),
                        _createElementVNode("p", _hoisted_9, _toDisplayString(record.verificationCode), 1),
                        _createElementVNode("p", _hoisted_10, [
                          _createElementVNode("small", _hoisted_11, [
                            _createTextVNode("Revalidate in "),
                            _createVNode(Duration, {
                              seconds: record.ttl
                            }, null, 8, ["seconds"])
                          ])
                        ])
                      ])
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            (_unref(processedRecords).spf.length !== 0)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  _hoisted_12,
                  _createVNode(SpfRecords, {
                    domain: __props.domain,
                    records: __props.records
                  }, null, 8, ["domain", "records"])
                ], 64))
              : _createCommentVNode("", true),
            (_unref(processedRecords).other.length !== 0 && _unref(processedRecords).verification.length !== 0)
              ? (_openBlock(), _createElementBlock("h3", _hoisted_13, "Other TXT records"))
              : _createCommentVNode("", true),
            (_unref(processedRecords).other.length !== 0)
              ? (_openBlock(), _createElementBlock("table", _hoisted_14, [
                  _hoisted_15,
                  _hoisted_16,
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(processedRecords).other, (record, index) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: index,
                        class: "group"
                      }, [
                        _createElementVNode("td", _hoisted_17, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(record.strings, (string, index) => {
                            return (_openBlock(), _createElementBlock("span", { key: index }, [
                              _hoisted_18,
                              _createTextVNode(_toDisplayString(string), 1),
                              _hoisted_19
                            ]))
                          }), 128)),
                          _createVNode(CnameChainBadge, {
                            chain: record.cnameChain
                          }, null, 8, ["chain"]),
                          _createVNode(Copy, {
                            content: record.raw,
                            class: "[visibility:hidden] group-hover:visible"
                          }, null, 8, ["content"])
                        ]),
                        _createElementVNode("td", null, [
                          _createVNode(Duration, {
                            seconds: record.ttl
                          }, null, 8, ["seconds"])
                        ])
                      ]))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_20, "No TXT records found."))
  ]))
}
}

})